"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.bmwLabels = void 0;
var types = __importStar(require("../labelTypes"));
exports.bmwLabels = (_a = {},
    _a[types.CREDIT_NAV_CARD] = 'Apply for Credit',
    _a[types.CREDIT_APP_TITLE] = 'Credit Application',
    _a[types.CREDIT_APP_DESCRIPTION] = '',
    _a[types.CREDIT_APP_DESCRIPTION_CREDITOVERWRITEBLOCK_TOGGLE] = 'Once your Credit Application is submitted, Payment ' +
        'Terms, Vehicle Protection, and Trade-In will no longer be changeable.',
    _a[types.ADVERTISED_PRICE] = 'Price',
    _a[types.DISCLAIMER] = 'The monthly payment amount shown is an estimate based upon the rate you enter or, if no ' +
        'rate is entered, the best terms available from this lender. Not all customers will qualify for these rates. ' +
        'Other rates and terms may be available to you based upon your personal credit history, program requirements, the vehicle ' +
        'or options you select, dealer participation, or other factors. Please visit your BMW Center for details about ' +
        'rate availability.',
    _a[types.SPECIALS_LINK] = 'Additional Offers',
    _a[types.TEST_DRIVE_TITLE] = 'Take it for a spin first',
    _a[types.TEST_DRIVE_DESCRIPTION] = '',
    _a[types.TEST_DRIVE_SUCCESS_TITLE] = 'TEST DRIVE SCHEDULED',
    _a[types.TEST_DRIVE_SUCCESS_DESCRIPTION] = 'Thanks for scheduling your test drive! A representative will reach out to you via ' +
        'your preferred communication method.  If you have immediate questions, please call us at the number below.',
    _a[types.PROTECT_VEHICLE_DESCRIPTION] = '',
    _a[types.PROTECT_VEHICLE_SECONDARY_HEADER] = '',
    _a[types.VEHICLE_PROTECTION_PRICE_TITLE] = 'Total',
    _a);
